import "@hotwired/turbo-rails"

import "core-js/actual"

// PWA
import "@khmyznikov/pwa-install"

if ("serviceWorker" in navigator) {
  console.log("[PWA] Registering service worker...")
  navigator.serviceWorker
    .register("/service-worker.js")
    .then((reg) => console.log("[PWA] Service worker registered:", reg.scope))
    .catch((err) => console.error("[PWA] Service worker registration failed:", err))
} else {
  console.log("[PWA] Service workers not supported")
}

import "@fortawesome/fontawesome-free/css/all.css"
import "tippy.js/dist/tippy.css"
import "../stylesheets/application.scss"

import "~/days"
import "~/shopping-list"
import "~/journal"
import "~/recipes"
import "~/stimulus"
import "~/pull-to-refresh"
